import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-client-setting',
  templateUrl: './client-setting.component.html',
  styleUrls: ['./client-setting.component.scss']
})
export class ClientSettingComponent {
  tabs = [
    { key: 'notification', label: 'Notification Configuration', icon: 'fa fa-envelope' },
    { key: 'communication', label: 'Communication Configuration', icon: 'fa fa-comments' },
    { key: 'whatsapp', label: 'Whatsapp Configuration', icon: 'fab fa-whatsapp' },
    { key: 'prescription', label: 'Prescription Templates', icon: 'fa fa-print' },
  ];

  currentTab = 'notification';

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.currentTab = params.get('tab') || 'notification'; 
      console.log('Active tab:', this.currentTab);
    });
  }
  changeTab(t: string) {
    this.currentTab = t;
  }
}
